// extracted by mini-css-extract-plugin
export var dark = "VideoCard-module--dark--8748d";
export var date = "VideoCard-module--date--90d16";
export var fadeInAnimation = "VideoCard-module--fadeInAnimation--268a0";
export var img = "VideoCard-module--img--8f8f3";
export var item = "VideoCard-module--item--b15e6";
export var picture = "VideoCard-module--picture--82237";
export var pictureWrapper = "VideoCard-module--pictureWrapper--6a305";
export var subtitle = "VideoCard-module--subtitle--7d39e";
export var tag = "VideoCard-module--tag--e3843";
export var text = "VideoCard-module--text--5ffa0";
export var time = "VideoCard-module--time--dccdd";
export var title = "VideoCard-module--title--5b068";